import { useState, useEffect } from "react";
import { Platform, Dimensions } from "react-native";
import { useSafeAreaFrame } from "react-native-safe-area-context";
import { minDesktopWidth } from "@/components/globalUtils";

/**
 * Custom hook to determine if the current screen size should use mobile UX
 * @returns {boolean} true if mobile UX should be used, false otherwise
 */
export const useIsMobileUX = () => {
  // For mobile platforms, use useSafeAreaFrame which works well
  const safeAreaFrame = useSafeAreaFrame();

  // For web, we need to listen to window resize events
  const [webWidth, setWebWidth] = useState(
    Platform.OS === "web"
      ? typeof window !== "undefined"
        ? window.innerWidth
        : 0
      : 0
  );

  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const handleResize = () => {
        setWebWidth(window.innerWidth);
      };

      // Initial width
      setWebWidth(window.innerWidth);

      // Add event listener
      window.addEventListener("resize", handleResize);

      // Cleanup
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  // Use appropriate width based on platform
  const width = Platform.OS === "web" ? webWidth : safeAreaFrame.width;

  return minDesktopWidth > width;
};

export default useIsMobileUX;
